import React, { useState, useEffect, useCallback } from 'react';

export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);
  const threshold = 300;

  const handleScroll = useCallback(() => {
    setVisible(window.scrollY > threshold || document.documentElement.scrollTop > threshold);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!visible) return null;

  return (
    <button
      type="button"
      className="sft-scroll-to-top"
      onClick={scrollToTop}
      aria-label="Scroll to top"
    >
      ↑
    </button>
  );
}
